import axios from 'axios'

import { CURRENCY as ENDPOINT } from '../common/endpoints.js'
import { error } from '../main/toast-notifications'

const saveBtn = document.querySelector('.j-switcher .c-cta')

saveBtn?.addEventListener('click', async function (e) {
	e.currentTarget.setAttribute('disabled', true)
	const currency = document.querySelector('.j-switcher .c-switcher__currencies')?.value || 'EUR'
	const langURL = document.querySelector('.j-switcher .c-switcher__languages')?.value || window.location.href

	try {
		await axios.post(ENDPOINT, {
			currency,
		})
		window.location.replace(langURL)
	} catch (err) {
		error(`${err.name}: ${err.message}`)
		e.currentTarget.removeAttribute('disabled')
	}
})
